import Grid from '@mui/material/Grid';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { useEffect, useState } from 'react';
import { FacetState } from '@coveo/headless';
import { setChangedFilterValue } from 'src/features/coveoSlice';
import { useDispatch } from 'react-redux';

const EnrollingSiteFilter = (props: any) => {
  const { controller } = props;
  const [state, setState] = useState<FacetState>(controller.state);
  const { fields } = props?.fields?.data[0];
  const dispatch = useDispatch();
  useEffect(() => controller.subscribe(() => setState(controller.state)), [controller]);

  if (!state.values.length) {
    return <></>;
  }
  const onChange = (value: any) => {
    controller.toggleSelect(value);
    dispatch(setChangedFilterValue(value));
  };
  return (
    <Grid item>
      <FormControlLabel
        label={<Text field={fields.label}></Text>}
        control={
          <Checkbox
            checked={controller.isValueSelected(state.values[0])}
            onChange={() => onChange(state.values[0])}
            disabled={state.isLoading}
            inputProps={{ 'aria-label': fields.label?.value }}
          />
        }
      />
    </Grid>
  );
};

export default EnrollingSiteFilter;
